<template>
  <h1 style="text-align: center; margin-top: 20vh;color: #909399;">
    <i class="el-icon-guide" /> 系统建设中...
  </h1>
</template>

<script>
export default {
  name: 'Developing'
}
</script>

<style scoped>

</style>
